import { convexClient, hasLiveConvex } from './convexClient';

export const friendService = {
  async getFriends(userId) {
    try {
      if (hasLiveConvex) {
        const friends = await convexClient.query("friends:getFriends", { userId });
        if (friends) return friends;
      }
      
      const localFriends = JSON.parse(localStorage.getItem('friends') || '{}');
      return localFriends[userId] || [];
    } catch (error) {
      console.error('Error fetching friends:', error);
      return [];
    }
  },

  async getPendingRequests(userId) {
    try {
      if (hasLiveConvex) {
        const requests = await convexClient.query("friends:getPendingRequests", { userId });
        if (requests) return requests;
      }
      
      const localRequests = JSON.parse(localStorage.getItem('friendRequests') || '[]');
      return localRequests.filter(req => req.receiverId === userId && req.status === 'pending');
    } catch (error) {
      console.error('Error fetching pending requests:', error);
      return [];
    }
  },

  async sendFriendRequest(senderId, receiverId) {
    try {
      if (hasLiveConvex) {
        await convexClient.mutation("friends:sendFriendRequest", { senderId, receiverId });
      }
      
      const localRequests = JSON.parse(localStorage.getItem('friendRequests') || '[]');
      // Check if already sent
      if (!localRequests.find(req => req.senderId === senderId && req.receiverId === receiverId)) {
        localRequests.push({
          id: Date.now().toString(),
          senderId,
          receiverId,
          status: 'pending',
          createdAt: new Date().toISOString()
        });
        localStorage.setItem('friendRequests', JSON.stringify(localRequests));
      }
      
      return { success: true };
    } catch (error) {
      console.error('Error sending friend request:', error);
      return { success: false, error: error.message };
    }
  },

  async handleRequest(requestId, action) {
    try {
      if (hasLiveConvex) {
        await convexClient.mutation("friends:handleRequest", { requestId, action });
      }
      
      const localRequests = JSON.parse(localStorage.getItem('friendRequests') || '[]');
      const requestIndex = localRequests.findIndex(req => req.id === requestId || req._id === requestId);
      
      if (requestIndex >= 0) {
        const request = localRequests[requestIndex];
        
        if (action === 'accept') {
          request.status = 'accepted';
          // Add to friends
          const localFriends = JSON.parse(localStorage.getItem('friends') || '{}');
          if (!localFriends[request.senderId]) localFriends[request.senderId] = [];
          if (!localFriends[request.receiverId]) localFriends[request.receiverId] = [];
          
          if (!localFriends[request.senderId].includes(request.receiverId)) {
             localFriends[request.senderId].push(request.receiverId);
          }
          if (!localFriends[request.receiverId].includes(request.senderId)) {
             localFriends[request.receiverId].push(request.senderId);
          }
          localStorage.setItem('friends', JSON.stringify(localFriends));
        } else {
          request.status = 'rejected';
        }
        
        localStorage.setItem('friendRequests', JSON.stringify(localRequests));
      }
      
      return { success: true };
    } catch (error) {
      console.error('Error handling friend request:', error);
      return { success: false, error: error.message };
    }
  }
};
